import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';

export const Modal = (props) => {
  const {
    title,
    children,
    open,
    onClose,
    onCancel,
    onClick,
    className,
    overlayClassName,
    bodyClassName,
    disableOverlayClick,
    customHeader: CustomHeader,
    shouldCloseOnOverlayClick,
  } = props;

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : 'visible';
  }, [ open ]);

  return open ? (
    <span onClick={(e) => { onClick && onClick(); e.stopPropagation(); }}>
      <ReactModal
        isOpen={true}
        closeTimeoutMS={300}
        className={`dialog ${className}`}
        overlayClassName={`overlay ${disableOverlayClick ? 'disabled' : ''} ${overlayClassName}`}
        onRequestClose={onClose || onCancel}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      >
        <div className="modalContainer">
          <div className="modalContent">
            {!CustomHeader ? (
              <div className="modalHeader">
                <div className="modalTitle">{title}</div>
                <div className="modalClose" onClick={onClose || onCancel}/>
              </div>
            ) : (
              <CustomHeader />
            )}
            <div className={`modalBody ${bodyClassName}`}>
              {children}
            </div>
          </div>
        </div>
      </ReactModal>
    </span>
  ) : null;
};

Modal.defaultProps = {
  className: '',
  overlayClassName: '',
  bodyClassName: '',
  shouldCloseOnOverlayClick: true,
};

Modal.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  onCancel: PropTypes.func,
  onClick: PropTypes.func,
  className: PropTypes.string,
  overlayClassName: PropTypes.string,
  bodyClassName: PropTypes.string,
  disableOverlayClick: PropTypes.bool,
  customHeader: PropTypes.func,
  shouldCloseOnOverlayClick: PropTypes.bool,
};

export default Modal;
